const collectionHandle = "summer-sale"; 
  let collectionProductIds = []; 

  // Fetch product IDs from the collection
  fetch(`/collections/${collectionHandle}/products.json?limit=250`)
    .then(response => response.json())
    .then(data => {
      collectionProductIds = data.products.map(product => product.id);
      console.log("Collection Product IDs:", collectionProductIds);
    })
    .catch(error => console.error("Error fetching collection products:", error));

  $(document).on("click", ".t4s-quantity-wrapper, .t4s-site-nav__cart, .t4s-product-form__buttons, .t4s-mini_cart__remove, .t4s-product-form__submit", function (e) {

    setTimeout(() => {
      fetch("/cart.js")
        .then(response => response.json())
        .then(cart => {
          console.log("Cart Data:", cart);

          let offerContainer = $("#cart-offer-container");
          let offerMessage = $("#cart-offer-message");
          let shopNowLink = $("#shop-now-link");

          let cartItemsInCollection = cart.items.filter(item => collectionProductIds.includes(item.product_id));

          let totalQty = cartItemsInCollection.reduce((sum, item) => sum + item.quantity, 0);

          if (totalQty >= 2) {
            offerMessage.text("🎉 Congratulations! You have unlocked Flat 20% off!");
            offerContainer.css({ "background": "green", "color": "white", "padding": "10px", "border-radius": "5px", "font-size": "14px" }).show();
            shopNowLink.hide();
          } else if (totalQty === 1) {
            offerMessage.text("Add 1 more to avail Flat 20% off!");
            offerContainer.css({ "background": "white", "color": "red", "padding": "10px", "border-radius": "5px", "font-size": "14px" }).show();
            shopNowLink.attr("href", `/collections/${collectionHandle}`).show();
          } else {
            offerContainer.hide();
          }
        })
        .catch(error => {
          console.error("Error fetching cart:", error);
        });
    }, 800);

    $("#cart-drawer").toggleClass("active");
  });